import { render } from "./CharacterSelectModal.vue?vue&type=template&id=457b2208&scoped=true"
import script from "./CharacterSelectModal.vue?vue&type=script&lang=js"
export * from "./CharacterSelectModal.vue?vue&type=script&lang=js"

import "./CharacterSelectModal.vue?vue&type=style&index=0&id=457b2208&scoped=true&lang=css"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457b2208"]])

export default __exports__